import { css } from '@emotion/react';
import { memo } from 'react';
import { globalGreen, globalRed } from '~/modules/AppLayout/Colors';
import { pureGrid } from '~/modules/AppLayout/FlexGridCss';
/**
 * 橫條圖表示百分比消長
 *
 * 40%, 32%, 10% -> 左半邊灰階，右半邊依照相對畫出紅條
 *
 * 最大為40%
 * 40% => 填滿右半邊，表示100%，props.denominator便是此數值
 *
 * 32% => 32/40, 變成80%
 *
 * 10% => 10/40, 變成25%，1/4滿的意思
 */
const PercentageBarChart = memo(function PercentageBarChart(props) {
    const { percentage, denominator, width } = props;
    const ref = denominator || 100;
    return (<div css={css `
        width: ${width ? width : 200}px;
        height: 16px;
        background: ${'#dbdbe6'};
        margin: 8px;
        border-radius: 16px;
        ${pureGrid};
        grid-template: 'green red';
      `}>
      <div css={css `
          grid-area: green;
          height: 100%;
          width: ${percentage < 0 ? (100 * Math.abs(percentage)) / ref : 0}%;
          background: ${getBarColor(percentage)};
          border-radius: 16px 0 0 16px;
          justify-self: flex-end;
        `}/>
      <div css={css `
          grid-area: red;
          height: 100%;
          width: ${percentage > 0 ? (100 * Math.abs(percentage)) / ref : 0}%;
          background: ${getBarColor(percentage)};
          border-radius: 0 16px 16px 0;
        `}/>
    </div>);
});
const getBarColor = (value) => {
    let color;
    if (value > 0)
        color = value > 50 ? (value > 80 ? globalRed.r600 : globalRed.r400) : '#dd4664';
    else if (value < 0)
        color = value < -50 ? (value < -80 ? globalGreen.g600 : '#32b866') : globalGreen.g200;
    return color;
};
export default PercentageBarChart;
